import { render, staticRenderFns } from "./TravelNavigator.vue?vue&type=template&id=84811ae2"
import script from "./TravelNavigator.vue?vue&type=script&lang=js"
export * from "./TravelNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports